import { ulid } from "ulid";

/** `<prefix>_<ulid>` — the format the API validates for the Idempotency-Key header. */
export const newIdempotencyKey = (prefix: string) => `${prefix}_${ulid()}`;
